import { render, staticRenderFns } from "./ModalDesativarAviso.vue?vue&type=template&id=05659890"
import script from "./ModalDesativarAviso.vue?vue&type=script&lang=js"
export * from "./ModalDesativarAviso.vue?vue&type=script&lang=js"
import style0 from "./ModalDesativarAviso.vue?vue&type=style&index=0&id=05659890&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports